<div class="px-8 mt-2 font-light">
    <div class="relative cursor-pointer pr-8" (click)="toggle.emit()">
        @if (vm().description) {
            <div class="relative whitespace-pre-line" [class.line-clamp-3]="!expanded()" data-testid="details_description">
                {{ vm().description }}
                @if (!expanded()) {
                    <!-- Not needed because we have a line clamp and ellipsis but removing it wrecks the close icon
                     so temporarily hidden: -->
                    <div class="hidden absolute inset-x-0 bottom-0 h-6 bg-[linear-gradient(to_top,var(--background_primary),transparent)]"></div>
                }
            </div>
        }

        @if (expanded() || !vm().description) {
            @if (vm().credits.length) {
                <div class="mt-3" data-testid="details_credits">
                    @for (credit of vm().credits; track credit.labelKey) {
                        <div class="mb-1"><span class="opacity-70">{{ credit.labelKey | transloco }}:</span> {{ credit.value }}</div>
                    }
                </div>
            }
        }

        @if ((expanded() || !vm().description) && vm().geoblockAreaLocalization) {
            <div class="mt-3 text-xs opacity-70" data-testid="details_geoblock">{{ vm().geoblockAreaLocalization }}</div>
        }

        @if (vm().description || vm().credits.length) {
            <i class="pi pi-chevron-down absolute bottom-0 mb-1 right-0 transition-transform duration-300"
                [class.rotate-180]="expanded()"></i>
        }
    </div>
</div>
